const initialState = {
  creatingPrize: false,
  createPrizeFormSubmitted: false,
  createdPrizeId: null,
  error: null
};

export default initialState;



// WEBPACK FOOTER //
// ./public/pages/PrizeCreator/initialState.js